var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-form',{staticClass:"row q-col-gutter-lg"},[_c('div',{staticClass:"col-xs-12 col-md-grow"},[_c('q-input',{ref:"phoneNumber",attrs:{"outlined":"","autocomplete":"tel","type":"tel","label":_vm.$t('payment.phoneNumber'),"rules":[
        v => !!v || _vm.$t('payment.validation.phoneNumber.required'),
        v => v && v.length >= 7 || _vm.$t('payment.validation.phoneNumber.tooShort'),
      ]},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }